import {ColumnsType} from "antd/lib/table";
import {BasketDto, BasketItemDto} from "../../api";
import {AsyncButtonPopconfirm, CrudTable, nameof} from "digimuth-components/dist";
import {CrudTableWrapperProps} from "digimuth-components/dist/components/crudTable/crudTable";

export default function BasketProductsList(props: BasketProductListProps) {
    const columns: ColumnsType<BasketDto> = [
        {
            key: nameof<BasketItemDto>("productId"),
            dataIndex: nameof<BasketItemDto>("productId"),
            title: "Id produktu"
        },
        {
            key: nameof<BasketItemDto>("name"),
            dataIndex: nameof<BasketItemDto>("name"),
            title: "Nazwa",
        },
        {
            key: nameof<BasketItemDto>("count"),
            dataIndex: nameof<BasketItemDto>("count"),
            title: "Ilość",
        },
        {
            key: nameof<BasketItemDto>("price"),
            dataIndex: nameof<BasketItemDto>("price"),
            title: "Cena",
        },
        {
            key: nameof<BasketItemDto>("unit"),
            dataIndex: nameof<BasketItemDto>("unit"),
            title: "Jednostka",
        },
    ];

    return <>
        <CrudTable
            data={props.data || []}
            onAddClicked={props.onAddClicked}
            onEditClicked={props.onEditClicked}
            onDeleteClicked={props.onDeleteClicked}
            isLoading={props.isLoading}
            deleteButtonTitle={"Usuń"}
            deleteConfirmMessage={"Czy na pewno chcesz usunąć ten wpis?"}
            cancelButtonTitle="Anuluj"
            columns={columns}
            customRowActions={(row) => <AsyncButtonPopconfirm
                title={"Czy na pewno usunąć ten produkt z koszyka"}
                danger
                onConfirm={() => props.customDeleteClicked(row.id!, row.count!)}>
                Usuń produkt z koszyka
            </AsyncButtonPopconfirm>}
        />
    </>
}

interface BasketProductListProps extends CrudTableWrapperProps<BasketItemDto, string> {
    customDeleteClicked: (id: string, count: number) => any;
}
